import { AuthEnv } from './types';

export const getLoggedInCookieName = (authEnv: AuthEnv): string => {
  switch (authEnv) {
    case AuthEnv.Stage:
      return 'stage_peloton_visited_sites';
    case AuthEnv.Test:
      return 'test_peloton_visited_sites';
    case AuthEnv.Prod:
    default:
      return 'peloton_visited_sites';
  }
};

/**
 * Returns true if the SSO marker cookie is present on the current document.
 *
 * Mirrors the legacy `@peloton/auth/helpers.ts#getContainsLoginCookie`.
 *
 * Wrapped in try/catch because `document.cookie` access can throw in
 * sandboxed iframes, blocked-cookie storage modes, and certain corporate
 * security extensions. A read failure here must never block AuthProvider
 * init — if we can't tell whether the marker exists, fall back to "no
 * cookie" (skip silent auth, same as a guest cold load).
 */
export const getContainsLoginCookie = (authEnv: AuthEnv): boolean => {
  try {
    if (typeof document === 'undefined' || !document.cookie) {
      return false;
    }
    const target = getLoggedInCookieName(authEnv);
    return !!document.cookie.split(' ').find(c => c.split('=')[0] === target);
  } catch {
    return false;
  }
};
